import client from '@/services/';

const state = () => ({
    all: [],
    one: null,
});

const getters = {
    all: state => state.all,
    one: state => state.one,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getCurrent({ commit }) {
        try {
            const { data } = await client.get('setting/current');
            commit('SET_ONE', data || null);
            return data || null;
        } catch (e) {
            commit('SET_ONE', null);
            return null;
        }
    },
    async addSetting({ commit }, payload) {
        const { data } = await client.post('/setting/add', payload);
        commit('SET_ONE', data);
        return data;
    },
    async editSetting({ commit }, payload) {
        const id = payload?.id;
        const { data } = await client.put(`/setting/edit/${id}`, payload);
        commit('SET_ONE', data);
        return data;
    },
    async deleteSetting({ commit }, id) {
        const { data } = await client.delete(`/setting/delete/${id}`);
        commit('SET_ONE', null);
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};